import {
    MIME_TYPE_PDF,
    MIME_TYPE_XLSX,
    MIME_TYPE_ZIP_STANDARD,
    MIME_TYPE_ZIP_WINDOWS,
    FILE_EXTENSION_PDF,
    FILE_EXTENSION_XLSX,
    FILE_EXTENSION_ZIP,
} from 'ProjectSubmission';

// Map MIME types to file extensions for fallback validation
const MIME_TYPE_TO_EXTENSIONS: Record<string, string[]> = {
    [MIME_TYPE_PDF]: [FILE_EXTENSION_PDF],
    [MIME_TYPE_XLSX]: [FILE_EXTENSION_XLSX],
    [MIME_TYPE_ZIP_STANDARD]: [FILE_EXTENSION_ZIP],
    [MIME_TYPE_ZIP_WINDOWS]: [FILE_EXTENSION_ZIP],
};

export const fileTypeValidator =
    (acceptedTypes: string, errorMessage: string) =>
    (file: File): Error | null => {
        const acceptedTypeArray = acceptedTypes.split(',').map(type => type.trim());

        // First, try to validate by MIME type
        if (file.type && acceptedTypeArray.some(type => file.type === type)) {
            return null;
        }

        // Fallback: If MIME type is empty (common on Windows),
        // check file extension as a secondary validation
        // Note: We only use extension fallback when MIME type is empty/missing,
        // not when it's present but wrong
        if (!file.type) {
            const fileName = file.name.toLowerCase();
            const acceptedExtensions = acceptedTypeArray.flatMap(type => MIME_TYPE_TO_EXTENSIONS[type] || []);

            if (acceptedExtensions.length > 0 && acceptedExtensions.some(ext => fileName.endsWith(ext))) {
                return null;
            }
        }

        return new Error(errorMessage);
    };
